export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    platformId: other.platformId || null,
    name: other.name || null,
    color: other.color || null,
    acronym: other.acronym || null,
    desk: other.desk || null,
    phone: other.phone || null,
    contactName: other.contactName || null,
    crm: other.crm || null,
    website: other.website || null,
    vipWebsite: other.vipWebsite || null,
    accountPath: other.accountPath || null,
    accountVipPath: other.accountVipPath || null,
    country: other.country || null,
    lang: other.lang || null,
    email: other.email || null,
    vat: other.vat || null,
    hebCalendar: other.hebCalendar || null,
    price: other.price || null,
    priceType: other.priceType || null,
    settings: other.settings || null,
    images: other.images || null,
    allowedDomains: other.allowedDomains || [],
    vipAllowedDomains: other.vipAllowedDomains || [],
    hostnames: other.hostnames || [],
    currency: other.currency || null,
    currencies: other.currencies || null,
    defaultTradeCurrency: other.defaultTradeCurrency || null,
    telegramTransactionsGroup: other.telegramTransactionsGroup || null,
    websiteHealthCheckUrl: other.websiteHealthCheckUrl || null,
  }
}
